module.exports = __webpack_public_path__ + "img/window_with_glob.899ebb00.svg";